<template>
  <div class="h5-container">
    <van-nav-bar
        class="top-bar"
        title="球杆激活"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    ></van-nav-bar>
    <div class="container-item">
      <van-form @submit="onBatchSubmit">
        <!-- 新增：主信息区域 -->
        <div class="main-info-wrap">
          <div class="main-info-title">个人信息</div>
          <!-- 姓名 -->
          <van-field
              v-model="mainForm.name"
              name="name"
              label="姓名"
              placeholder="请输入姓名"
              :rules="[{ required: true }]"
          />
          <!-- 手机号 -->
          <van-field
              v-model="mainForm.phone"
              name="phone"
              label="手机号"
              placeholder="请输入手机号"
              type="tel"
              :rules="[
                { required: true },
                { pattern: mobileReg, message: '请输入正确的手机号' }
              ]"
          />
          <!-- 身份证号（选填） -->
          <van-field
              v-model="mainForm.idCard"
              name="idCard"
              label="身份证号"
              placeholder="请输入身份证号（选填）"
              :rules="[{ validator: validateIdCard,message: '请输入正确的身份证号', required: false }]"
          />
          <!-- 联系地址 -->
          <van-field
              v-model="mainForm.address"
              name="address"
              label="联系地址"
              placeholder="请输入联系地址"
              :rules="[{ required: true }]"
              type="textarea"
              rows="2"
          />
        </div>

        <!-- 球杆信息标题 -->
        <div class="cue-info-title">球杆信息（可批量添加）</div>

        <!-- 批量球杆列表 -->
        <div v-for="(item, index) in batchFormList" :key="index" class="batch-item">
          <div class="batch-item-header">
            <span class="header-span">球杆 {{ index + 1 }}</span>
            <van-icon
                name="cross"
                class="delete-icon"
                @click="deleteBatchItem(index)"
                v-if="batchFormList.length > 1"
            />
          </div>

          <!-- 球杆编号 -->
          <van-field
              v-model="item.number"
              name="number"
              label="球杆编号"
              placeholder="请输入球杆编号"
              :rules="[{ required: true }]"
          />

          <!-- 球杆品牌 -->
          <van-field
              readonly
              clickable
              name="brand"
              :value="item.brand"
              label="球杆品牌"
              placeholder="点击选择球杆品牌"
              @click="openBrandSelectDialog(index)"
              class="search-input"
              :rules="[{ required: true }]"
          />
          <van-popup v-model="showBrandPicker" position="bottom">
            <van-picker
                show-toolbar
                :columns="selectOptions"
                @confirm="onBrandConfirm"
                @cancel="showBrandPicker = false"
            />
          </van-popup>

          <!-- 球杆型号 -->
          <van-field
              readonly
              clickable
              name="model"
              :value="item.model"
              label="球杆型号"
              placeholder="点击选择球杆型号"
              @click="openModelSelectDialog(index)"
              class="search-input"
              :rules="[{ required: true }]"
          />
          <van-popup v-model="showModelPicker" position="bottom">
            <van-picker
                show-toolbar
                :columns="selectModelOptions"
                @confirm="onModelConfirm"
                @cancel="showModelPicker = false"
            />
          </van-popup>

          <!-- 购买渠道 -->
          <van-field
              v-model="item.channel"
              name="channel"
              label="购买渠道"
              placeholder="请输入购买渠道"
              :rules="[{ required: true}]"
          />

          <!-- 购买价格 -->
          <van-field
              v-model="item.price"
              name="price"
              label="购买价格"
              placeholder="请输入购买价格"
              type="number"
              :rules="[{ required: true }]"
          />

          <!-- 购买时间 -->
          <van-field
              readonly
              clickable
              name="startTime"
              :value="item.startTime"
              label="购买时间"
              placeholder="点击选择购买时间"
              :rules="[{ required: true }]"
              @click="() => openCalendar(index)"
          />
          <van-datetime-picker
              v-if="showCalendar"
              v-model="currentDate"
              type="date"
              title="选择年月日"
              @confirm="onConfirm"
          />

          <!-- 购买凭证 -->
          <van-field
              name="fileList"
              label="购买凭证"
              :rules="[{ required: true, message: '请上传购买凭证' }]"
          >
            <template #input>
              <van-uploader v-model="item.fileList" multiple :max-count="3" />
            </template>
          </van-field>
        </div>

        <!-- 添加新球杆按钮 -->
        <div style="margin: 16px;">
          <van-button
              class="add-item-btn"
              round
              block
              type="default"
              @click="addBatchItem"
          >
            添加新球杆
          </van-button>
        </div>

        <!-- 批量提交按钮 -->
        <div style="margin: 16px;">
          <van-button class="submit-btn" round block type="info" native-type="submit">批量激活</van-button>
        </div>

      </van-form>
    </div>
  </div>
</template>

<script>
import '@/assets/css/mobileGlobal.scss';
import {Dialog, Toast} from "vant";
import {brandDropDown, memberRegister} from "@/api/sales";

export default {
  data(){
    return {
      // 新增：主信息表单数据
      mainForm: {
        name: '',        // 姓名（必填）
        phone: '',       // 手机号（必填）
        idCard: '',      // 身份证号（选填）
        address: ''      // 联系地址（必填）
      },
      // 手机号正则
      mobileReg: /^1[3-9]\d{9}$/,
      // 身份证号正则（18位）
      idCardReg: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,

      // 批量表单数据列表
      batchFormList: [
        {
          number: '',
          brand: '',
          brandCode: '',
          model: '',
          modelCode: '',
          channel: '',
          price: '',
          startTime: '',
          fileList: []
        }
      ],

      //购买时间日历组件是否显示
      showCalendar: false,
      currentDate: new Date(), // 初始设置为当前日期和时间
      targetIndex: 0,         // 批量表单的目标索引

      //球杆品牌
      selectBrandDrop: [],    // 品牌下拉数据源
      showBrandPicker: false,
      selectOptions: [],

      //球杆型号
      showModelPicker: false,
      selectModelOptions: [],

    }
  },
  created() {
    this.selectBrandDropDown();
  },
  methods: {
    validateIdCard(value) {
      // 只有当身份证号不为空时，才执行正则校验
      if (value && !this.idCardReg.test(value)) {
        return false; // 校验失败，返回错误提示
      } else {
        return true; // 校验通过（为空 或 格式正确）
      }
    },
    //获取品牌、系列下拉数据
    async selectBrandDropDown(){
      try {
        const response = await brandDropDown();
        if(response.code===200){
          this.selectBrandDrop = response.data;
        }
      } catch (error) {
        console.error("获取产品失败:", error);
      }
    },
    //品牌点击事件
    openBrandSelectDialog(index){
      this.targetIndex = index;
      this.showBrandPicker = true;
      this.selectOptions = this.selectBrandDrop.map(item=>({
        text: item.value,
        value: item.label
      }));
    },
    //品牌确认事件
    onBrandConfirm(value, index){
      const selectedItem = this.selectOptions[index];
      const target = this.getTargetForm();

      if (target) {
        target.brandCode = selectedItem.value;
        target.brand = selectedItem.text;
      }
      this.showBrandPicker = false;
    },
    //型号点击事件
    openModelSelectDialog(index){
      this.targetIndex = index;
      const target = this.getTargetForm();
      console.log(245,target);

      if (!target?.brandCode) {
        this.showDialogMsg("请先选择球杆品牌");
        return;
      }
      this.showModelPicker = true;
      this.selectModelOptions = this.selectBrandDrop
          .find(parent => parent.label === target.brandCode)
          ?.children.map(child => ({ text: child.value, value: child.label })) ?? [];
    },
    //型号确认事件
    onModelConfirm(value, index){
      const selectedItem = this.selectModelOptions[index];
      const target = this.getTargetForm();

      if (target) {
        target.modelCode = selectedItem.value;
        target.model = selectedItem.text;
      }
      this.showModelPicker = false;
    },

    // 打开日期选择器
    openCalendar(index) {
      console.log(347,index);
      this.targetIndex = index;
      this.showCalendar = true;
    },

    //购买日期日历组件确认事件
    onConfirm(date) {
      const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
      console.log(354,formattedDate);
      const target = this.getTargetForm();

      console.log(357,target);
      if (target) {
        target.startTime = formattedDate;
      }
      this.showCalendar = false;
    },

    // 获取目标表单对象
    getTargetForm() {
      return this.batchFormList[this.targetIndex];
    },

    //顶部标题栏返回事件
    onClickLeft() {
      this.$router.push('/app_home');
    },
    //提示语
    showDialogMsg(message){
      Dialog.alert({
        title: '提示',
        message: message,
      });
    },

    // 添加新的批量表单条目
    addBatchItem() {
      this.batchFormList.push({
        number: '',
        brand: '',
        brandCode: '',
        model: '',
        modelCode: '',
        channel: '',
        price: '',
        startTime: '',
        fileList: []
      });
    },

    // 删除批量表单条目
    deleteBatchItem(index) {
      Dialog.confirm({
        title: '提示',
        message: '确认要删除球杆'+(index+1)+'吗？',
      })
          .then(() => {
            this.batchFormList.splice(index, 1);
          })
    },

    //球杆激活提交 - 改造：新增主信息提交
    async onBatchSubmit(){
      console.log('主信息:', this.mainForm);
      console.log('批量球杆数据:', this.batchFormList);

      // 2. 验证球杆编号唯一性
      const numbers = this.batchFormList.map(g => g.number)
      const duplicateNumbers = numbers.filter((num, index) =>
          num && numbers.indexOf(num) !== index
      )

      if (duplicateNumbers.length > 0) {
        this.showDialogMsg('球杆编号不能重复，请修改后重试');
      }

      const formData = new FormData();

      // 新增：添加主信息到提交参数
      formData.append('userName', this.mainForm.name); // 姓名
      formData.append('phoneNumber', this.mainForm.phone); // 手机号
      formData.append('identityCard', this.mainForm.idCard || ''); // 身份证号（选填）
      formData.append('address', this.mainForm.address); // 联系地址

      // 原有：添加球杆批量信息
      this.batchFormList.forEach((item, index) => {
        // 格式：productList[索引].属性名
        formData.append(`productList[${index}].number`, item.number); // 球杆编号
        formData.append(`productList[${index}].brand`, item.brand); // 品牌
        formData.append(`productList[${index}].model`, item.model); // 型号
        formData.append(`productList[${index}].brandCode`, item.brandCode); // 品牌编码
        formData.append(`productList[${index}].modelCode`, item.modelCode); // 型号编码
        formData.append(`productList[${index}].channel`, item.channel); // 购买渠道
        formData.append(`productList[${index}].price`, item.price); // 价格
        formData.append(`productList[${index}].startTime`, item.startTime); // 购买时间

        const fileList = item.fileList;
        const key = item.number.trim();
        if (Array.isArray(fileList) && fileList.length > 0) {
          fileList.forEach(file => {
            if (file.file) { // 确保原生文件对象存在
              formData.append(key, file.file);
            }
          });
        }
      });

      try {
        const res = await memberRegister(formData);
        if (res.code === 200) {
          Toast(res.code === 200 ? res.returnMsg : '注册失败，请重试');
          // 提交成功后重置表单（可选）
          this.mainForm = { name: '', phone: '', idCard: '', address: '' };
          this.batchFormList = [{ number: '', brand: '', brandCode: '', model: '', modelCode: '', channel: '', price: '', startTime: '', fileList: [] }];
          setTimeout(() => {
            this.$router.push('/app_login');
          }, 1000);

        } else {
          Toast(res.returnMsg);
        }
      } catch (error) {
        Toast('提交失败，请稍后重试');
      }
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep .van-icon-arrow-left {
  color: #0f0f0f !important;
}
::v-deep .van-nav-bar__text {
  color: #0f0f0f !important;
}
.top-bar{
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
}
.container-item {
  margin-bottom: 60px;
  padding: 0 8px;
}
.submit-btn{
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  border: none;
}

// 新增：主信息区域样式
.main-info-wrap {
  background: #f9f9f9;
  border-radius: 8px;
  padding: 15px;
  margin: 15px;

  .main-info-title {
    font-size: 18px;
    font-weight: bold;
    color: #222;
    margin-bottom: 15px;
    padding-bottom: 8px;
    border-bottom: 1px solid #eee;
  }
}

// 新增：球杆信息标题样式
.cue-info-title {
  font-size: 18px;
  font-weight: bold;
  margin: 15px 15px 8px;
}

// 批量球杆样式
.batch-item {
  padding: 10px;
  background: #f9f9f9;
  border-radius: 8px;
  margin: 15px;

  &-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .delete-icon {
    color: #f56c6c;
    font-size: 16px;
  }
}
.header-span{
  font-size: 16px;
  color: #222;
}
.add-item-btn {
  border: 1px dashed #ccc;
  color: #666;
}

// 适配textarea样式
::v-deep .van-field__control {
  min-height: auto;
}
</style>